import { createImmutableObjectClass } from 'immutable-less';
export default class StaticField extends createImmutableObjectClass({
  value: null,
  valueType: 'SINGLE'
}) {
  getIsValueEmpty() {
    return !this.value;
  }
  getValue() {
    return this.value;
  }
  /**
   * @deprecated Prefer dot notation: .valueType
   */
  getValueType() {
    return this.valueType;
  }
}